import React from "react";
import { useParams } from "react-router-dom";
import { ESRQuestionConfig } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";
import getBackendURL from "../../api/api";
import {download, preview} from "../../request";
import {Download, Visibility} from "@mui/icons-material";
import {Button, IconButton} from "@mui/material";

export const ESRLinkField = (props: ESRQuestionConfig) => {
	const { question_id, required, field_options, locked } = props;
	const { esrId = "" } = useParams();
	const [clowderID, setValue, setLocalValue] = useRemoteField(
		question_id,
		field_options.length > 0 ? field_options[0] : "",
	);

	const url = getBackendURL(
		"/esr/attachment/?esr_id=" + esrId + "&file_id=" + clowderID,
	);

	return (
		<>
			<IconButton
				aria-label="download file"
				color="secondary"
				onClick={() => download(url)}
			>
				<Download />
			</IconButton>
			<IconButton
				aria-label="preview file"
				color="secondary"
				onClick={() => preview(url)}
			>
				<Visibility />
			</IconButton>
		</>
	);
};
